import React from 'react';
import {connect} from "react-redux";
import {Dummy, Status, StatusBA} from '../';
import classNames from 'classnames';
import {htmlParam} from "../../../lib/utils";
import styles from './style.css';

export class Mainentry extends Dummy {

    render() {

        return (
            <div className={classNames(styles.main, 'row')}>
                <div className={classNames('col-xs-2', styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>&nbsp;<br/>ЦП зв'язок</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_-1_62']} zeroText="Є зв’язок" oneText="Нема зв’язку"
                                        zeroClass={styles.statusConnOk} oneClass={styles.statusConnBad}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>&nbsp;<br/>Режим роботи</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_21']} zeroText="Лiто" oneText="Зима"
                                        zeroClass={styles.statusSummer} oneClass={styles.statusWinter}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>&nbsp;<br/>Режим управління
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_35']} zeroText="Зовнішнє" oneText="Автономне"
                                        zeroClass={styles.statusControlExternal} oneClass={styles.statusControlAuto}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>&nbsp;<br/>Опалювальний сезон
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_126_100']} zeroText="Вимкнен" oneText="Ввімкнен"
                                        zeroClass={styles.statusSeasonOff} oneClass={styles.statusSeasonOn}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>Температура<br/>на об'єкті
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_51']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>&nbsp;<br/>Ручний стоп</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_52']} zeroText="Вимкнен" oneText="Ввімкнен"
                                        zeroClass={styles.statusStopOff} oneClass={styles.statusStopOn}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={classNames('col-xs-2', styles.blueBorder, styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)}>Рівень води в баку<br/>
                                    аккумуляторі
                                </th>
                            </tr>
                            <tr>
                                <StatusBA
                                    norm={this.props.params['tc_8_97_77']}
                                    low={this.props.params['tc_8_97_47']}
                                    high={this.props.params['tc_8_97_46']}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.title, styles.paddingTh)} colSpan="2">Витрати води<br/>через
                                    навантаження
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Q м3/ч</th>
                                {htmlParam(this.props.params['ti_8_94_25'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Витрати води<br/>через
                                    теплообмінник
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Q м3/ч</th>
                                {htmlParam(this.props.params['ti_8_98_3'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Циркуляційні насоси<br/>
                                    Н1,Н2
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_90_28']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Циркуляційні насоси<br/>
                                    Н3,Н4
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_91_28']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Тиск води в системі<br/>навантаження
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_50']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={classNames(styles.purpleBorder, 'col-xs-2', styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Температура<br/>зовнішнього
                                    повітря
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>T °C</th>
                                {htmlParam(this.props.params['ti_8_96_3'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Температура в
                                    баці<br/>аккумуляторі
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>T °C</th>
                                {htmlParam(this.props.params['ti_8_96_1'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Температура
                                    на<br/>об'єкті (поточна)
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>T °C</th>
                                {htmlParam(this.props.params['ti_8_96_4'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Температура
                                    на<br/>об'єкті (завдання)
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.red, styles.caption, styles.paddingTh)}>Tзд °C</th>
                                {htmlParam(this.props.params['ti_8_96_22'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Індукційний нагрівач<br/> ЕК1
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_44']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Індукційний нагрівач<br/> ЕК2
                                </th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_45']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Витяжний вентилятор В1</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_42']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Витяжний вентилятор В2</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_43']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className={classNames('col-xs-2', styles.grayBorder, styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>&nbsp;<br/>Ввод №1</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_48']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>&nbsp;<br/>Ввод №2</th>
                            </tr>
                            <tr>
                                <Status ps={this.props.params['tc_8_97_49']} zeroText="У нормi" oneText="Аварiя"
                                        zeroClass={styles.statusNorm} oneClass={styles.statusAvar}/>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="3">&nbsp;<br/>Миттєві
                                    показники
                                </th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}>PI(1)</th>
                                <th className={styles.subtitle}>U(B)</th>
                                <th className={styles.subtitle}>I(A)</th>

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза А</th>
                                {htmlParam(this.props.params['ti_8_92_141'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_92_151'], 'th', styles.disabled, styles.value)}

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза B</th>
                                {htmlParam(this.props.params['ti_8_92_142'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_92_152'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза C</th>
                                {htmlParam(this.props.params['ti_8_92_143'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_92_153'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.subtitle}>PI(2)</th>
                                <th className={styles.subtitle}>U(B)</th>
                                <th className={styles.subtitle}>I(A)</th>

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза А</th>
                                {htmlParam(this.props.params['ti_8_93_141'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_151'], 'th', styles.disabled, styles.value)}

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза B</th>
                                {htmlParam(this.props.params['ti_8_93_142'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_152'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза C</th>
                                {htmlParam(this.props.params['ti_8_93_143'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_153'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.subtitle}>W</th>
                                <th className={styles.subtitle}>PI1(кВт)</th>
                                <th className={styles.subtitle}>PI2(кВт)</th>

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза А</th>
                                {htmlParam(this.props.params['ti_8_92_101'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_101'], 'th', styles.disabled, styles.value)}

                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза B</th>
                                {htmlParam(this.props.params['ti_8_92_102'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_102'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Фаза C</th>
                                {htmlParam(this.props.params['ti_8_92_103'], 'th', styles.disabled, styles.value)}
                                {htmlParam(this.props.params['ti_8_93_103'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Накопичені
                                    показники
                                </th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}/>
                                <th className={styles.subtitle}>Енергія</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>W(кВт*г)</th>
                                {htmlParam(this.props.params['ti_8_95_1'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T1 W(кВт*г</th>
                                {htmlParam(this.props.params['ti_8_95_3'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T2 W(кВт*г</th>
                                {htmlParam(this.props.params['ti_8_95_3'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>T3 W(кВт*г</th>
                                {htmlParam(this.props.params['ti_8_95_4'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Q(кВар*г)</th>
                                {htmlParam(this.props.params['ti_8_95_21'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={classNames('col-xs-2', styles.lightblueBorder, styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Діючі тарифи у грн:<br/>Електроенергія(за
                                    1 кВт*г)
                                </th>
                            </tr>
                            <tr>
                                {htmlParam(this.props.params['ti_8_126_6'], 'th', styles.disabled, [styles.value, styles.oneCell, styles.paddingTh])}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)}>Теплоенергія<br/>(за 1 Гкал)
                                </th>
                            </tr>
                            <tr>
                                {htmlParam(this.props.params['ti_8_126_10'], 'th', styles.disabled, [styles.value, styles.oneCell, styles.paddingTh])}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="4">&nbsp;<br/>Собівартість
                                    1 ГКал
                                </th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}/>
                                <th className={styles.subtitle}>грн.</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Доба</th>
                                {htmlParam(this.props.params['ti_8_126_23'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Декада</th>
                                {htmlParam(this.props.params['ti_8_126_29'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон</th>
                                {htmlParam(this.props.params['ti_8_126_46'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Попер. сезон</th>
                                {htmlParam(this.props.params['ti_8_126_53'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Весь період</th>
                                {htmlParam(this.props.params['ti_8_126_39'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="4"> Економія</th>
                            </tr>
                            <tr>
                                <th className={styles.subtitle}/>
                                <th className={styles.subtitle}>грн.</th>
                            </tr>
                            <tr>
                                <th className={styles.caption}>Доба</th>
                                {htmlParam(this.props.params['ti_8_126_22'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Декада</th>
                                {htmlParam(this.props.params['ti_8_126_28'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Сезон</th>
                                {htmlParam(this.props.params['ti_8_126_45'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Попер. сезон</th>
                                {htmlParam(this.props.params['ti_8_126_52'], 'th', styles.disabled, styles.value)}
                            </tr>
                            <tr>
                                <th className={styles.caption}>Весь період</th>
                                {htmlParam(this.props.params['ti_8_126_38'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className={classNames('col-xs-2', styles.mainPadding)}>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Потужність<br/>
                                    генерації поточна
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Ртг(кВт)</th>
                                {htmlParam(this.props.params['ti_8_127_1'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Потужність<br/>споживання
                                    поточна
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Ртн(кВт)</th>
                                {htmlParam(this.props.params['ti_8_127_3'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Потужність<br/>втрат
                                    поточна
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Ртп(кВт)</th>
                                {htmlParam(this.props.params['ti_8_127_7'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Показники
                                    бака<br/>Запас ходу
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Тз(годин)</th>
                                {htmlParam(this.props.params['ti_8_127_9'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Запас енергії
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Wз(кВт*г)</th>
                                {htmlParam(this.props.params['ti_8_127_5'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="row">
                        <table className={styles.tg}>
                            <tbody>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.title)} colSpan="2">Дефіцит енергії
                                </th>
                            </tr>
                            <tr>
                                <th className={classNames(styles.paddingTh, styles.caption)}>Wд(кВт*г)</th>
                                {htmlParam(this.props.params['ti_8_127_6'], 'th', styles.disabled, styles.value)}
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}

Mainentry.propTypes = {
    openModal: React.PropTypes.func,
};

const mapStateToProps = (state) => {
    return {
        params: state.params
    };
};

export default connect(mapStateToProps)(Mainentry);



// WEBPACK FOOTER //
// ./src/components/entries/Mainentry/index.jsx